import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const LeftYAxis = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="LeftYAxis"
    {...props}
  >
    <rect x={2} y={2} width={1.33333} height={12} fill="#394959" />
    <rect x={4.66406} y={12.666} width={2} height={1.33333} fill="#394959" />
    <rect x={8} y={12.666} width={2} height={1.33333} fill="#394959" />
    <rect x={11.335} y={12.666} width={2} height={1.33333} fill="#394959" />
    <path
      d="M5.33594 5.33398H6.94424L7.98185 7.50065H8.02336L9.06097 5.33398H10.6693L8.71856 8.99023V10.6673H7.28665V8.99023L5.33594 5.33398Z"
      fill="#394959"
    />
  </svg>
);
export default React.memo(LeftYAxis);
